import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";

export interface MessageConfig {
  severity: "success" | "error" | "warning" | "info";
  summary: string;
  detail: string;
  life?: number; // duração em ms (opcional)
}

@Injectable({
  providedIn: "root",
})
export class MessageService {
  constructor(private toastrService: ToastrService) {}

  add(config: MessageConfig): void {
    const options = {
      timeOut: config.life || 3000,
      closeButton: true,
      progressBar: true,
    };

    switch (config.severity) {
      case "success":
        this.toastrService.success(config.detail, config.summary, options);
        break;
      case "error":
        this.toastrService.error(config.detail, config.summary, options);
        break;
      case "warning":
        this.toastrService.warning(config.detail, config.summary, options);
        break;
      case "info":
        this.toastrService.info(config.detail, config.summary, options);
        break;
      default:
        this.toastrService.info(config.detail, config.summary, options);
    }
  }

  // Métodos de conveniência
  success(summary: string, detail: string, life?: number): void {
    this.add({ severity: "success", summary, detail, life });
  }

  error(summary: string, detail: string, life?: number): void {
    this.add({ severity: "error", summary, detail, life });
  }

  warning(summary: string, detail: string, life?: number): void {
    this.add({ severity: "warning", summary, detail, life });
  }

  info(summary: string, detail: string, life?: number): void {
    this.add({ severity: "info", summary, detail, life });
  }

  clear(): void {
    this.toastrService.clear();
  }
}
